import { Text } from '@medly-components/core';
import styled from 'styled-components';
import Styled from '../Styled';

export const FormHeader = styled(Text)<{ width: string }>`
    color: ${({ theme }) => theme.colors.darkBlue};
    width: ${({ width }) => width};
    margin-bottom: 3.2rem;
    @media (max-width: ${({ theme }) => {
            return theme.breakpoints.M.max;
        }}px) {
        width: 100%;
        font-size: 2.4rem;
        line-height: 3.2rem;
    }
`;

export const FormWrapper = styled(Styled.FlexBox)`
    background: none;
    width: 100%;
    margin: 4rem 0 2.4rem;
    padding: 0 2.4rem;
    height: auto;
    box-sizing: border-box;
    max-width: 44rem;
    justify-content: center;
    min-height: fit-content;

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        margin: 7.2rem 9.6rem;
        max-width: 44rem;
        padding: 0;
        align-items: flex-start;
        justify-content: flex-start;
    }
`;

export const FormInputContainer = styled(Styled.FlexBox)`
    div {
        margin: 0;
    }
    label {
        padding: 0;
    }
    .terms-and-condition {
        align-items: flex-start;
    }
`;

export const MediumHeader = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
    width: 51.9rem;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        font-size: 2rem;
        line-height: 2.8rem;
        width: 100%;
    }
`;
